export default async () => {
    // season switch button

    Array.from(document.querySelectorAll('.tf-season-switcher button, .mobile-season-switch-btn')).forEach(btn => {
        btn.addEventListener("click", () => {
            window.seasonManager.switchSeason()
        })
    })
}